const getPathType = (route: string) => {
  const routes = route.split('/')

  if (routes[1] === '' || routes[1] === 'search') {
    return 'general'
  } else if (routes[1] === 'images') {
    return 'images'
  } else if (routes[1] === 'videos') {
    return 'videos'
  } else if (routes[1] === 'news') {
    return 'news'
  } else {
    return ''
  }
}

export default getPathType
